
import { NgModule } from '@angular/core';

import { AuthConfigModule } from './auth/auth-config.module';

import { SabisNgxModalsModule, SabisNgxNotificationsModule, SABISTranslateConfig, SDPTranslateModule } from 'sabis-components2';
import { TranslateModule } from '@ngx-translate/core';

import { CookieService } from 'ngx-cookie-service';
import { ToastrModule } from 'ngx-toastr';
import { RouteReuseStrategy } from '@angular/router';
import { CareersRouteReuseStrategy } from './routing/careers-route-reuse-strategy';
import { RouteCachingService } from '../@theme/shared/services/route-caching.service';

@NgModule({
  declarations: [
  ],
  imports: [
    AuthConfigModule,

    SabisNgxNotificationsModule,
    SabisNgxModalsModule,

    // for components (import only once to use one config across all the app)
    SDPTranslateModule,
    TranslateModule.forRoot(SABISTranslateConfig),
    ToastrModule.forRoot()
  ],
  providers: [
    CookieService,
    {
      provide: RouteReuseStrategy, useClass: CareersRouteReuseStrategy, deps: [RouteCachingService]
    }
    // already provided in app.module (when provided twice, it causes error messages to pop up twice)
    //{ provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
  ]
})
export class CoreModule { }
